import { Reaction } from 'src/hook/usePosts'
import { OnReactionErrorParams } from './reactionsList/types'

export type EmojiProps = {
  id: string
  keywords: string[]
  name: string
  native: string
  shortcodes: string
  unified: string
}

export type ReactionsBarProps = {
  postId: number
  reactionsParam: Reaction[]
  showAnimation?: boolean
  className?: string
  onReactionSuccess?: () => void
  onReaction?: () => void
  onReactionError?: ({ statusCode, errorMessage }: OnReactionErrorParams) => void
}

export enum ReactionsOption {
  LIKE = 'like',
  UNLIKE = 'unlike'
}
